import { addressTooltipText } from '../../../common/SharedFunctions';
import { Tooltip } from 'devextreme-react/tooltip';

export const onCityCellRender = (e) => {
    const targetId = `got_city_${e.data.id}}`;
    const text = addressTooltipText(e.data);
    return (
        <>
            <div
                data-tip
                data-for={targetId}
            >
                {e.data.city}
            </div>
            <Tooltip
                target={`[data-for="${targetId}"]`}
                showEvent='mouseenter'
                hideEvent='mouseleave'
                hideOnOutsideClick={false}
            >
                {text}
            </Tooltip>
        </>
    );
};
